<template>
  <div>
    <v-card-title>
      <v-text-field
          class="mt-5"
          outlined
          dense
          label="Search"
          v-model="searchTerm"
          @input="onChangeSearch"
      >
      </v-text-field>
      <v-switch
          class="ml-3"
          label="available in stock"
          v-model="availableInStock"
          @change="onChangeSearch"
      >
      </v-switch>
      <BaseDeleteDialog
          class="ml-3"
          :disabled="!(selectedItemList.length > 0)"
          :onDeleteAction="onDeleteSelected"
      >Delete
      </BaseDeleteDialog>
      <v-btn
          class="ml-3"
          color="primary" dense
          :disabled="!(selectedItemList.length > 0)"
          @click="onUpdateSelected"
      >Update
      </v-btn>
      <BrandComponentPCEditDialog
          v-if="brandComponentId != null"
          class="ml-3 mt-2"
          buttonText="Add"
          title="Add item"
          :isNewItem="true"
          v-model="newItem"
          @change="onAddItem"
          :brandComponentId="brandComponentId"
      >
      </BrandComponentPCEditDialog>
    </v-card-title>
    <v-card-text>
      <v-data-table
          v-bind="{...$props}"
          :headers="columns"
          :items="getProviderComponentList"
          item-key="id"
          class="elevation-1"
          dense
          fixed-header
          show-select
          :loading="loading"
          :options.sync="options"
          @update:options="updateOptions"
          :footer-props="{
            'items-per-page-options': [20, 50, 100]
          }"
          :server-items-length="totalRecords"
          v-model="selectedItemList"
      >
        <template v-slot:item.last_check="{ item }">
          {{ item.last_check | moment("YY.MM.DD HH:mm") }}
        </template>
        <template v-slot:item.actions="{ item }">
          <BrandComponentPCEditDialog
              icon="mdi-pencil"
              title="Edit item"
              :isNewItem="false"
              color="primary"
              small
              v-model="item"
              :onSaveAction="onEditItem"
          >
          </BrandComponentPCEditDialog>
        </template>
        <template v-slot:item.part_number="{ item }">
          <a :href="item.source" target="target">{{ item.part_number }}</a>
        </template>
        <template v-slot:item.prices="{ item }">
          <table cellspacing="5" cellpadding="3">
            <tr v-for="(value, name) in item.prices">
              <td nowrap>{{ name }}</td>
              <td nowrap>{{ value }}</td>
            </tr>
          </table>
        </template>
        <template v-slot:item.stocks="{ item }">
          <table cellspacing="5" cellpadding="3">
            <tr v-for="(value, name) in item.stocks">
              <td nowrap>{{ name }}</td>
              <td nowrap>{{ value }}</td>
            </tr>
          </table>
        </template>
      </v-data-table>
    </v-card-text>
  </div>
</template>

<script>
import {mapGetters, mapActions, mapMutations} from "vuex";
import {mapFields} from 'vuex-map-fields';
import BaseDeleteDialog from "@/components/BaseDeleteDialog";
import BrandComponentPCEditDialog from "@/components/Brand/BrandComponentPCEditDialog";

export default {
  name: 'BrandComponentProviderComponent',
  inheritAttrs: false,
  props: {
    'brandComponentId': [String, Number],
    'hide-default-footer': {type: Boolean, default: false},
    'height': {
      type: [Number, Function], default: function () {
        return this.$vuetify.breakpoint.height - 220
      }
    },
  },
  components: {
    BaseDeleteDialog,
    BrandComponentPCEditDialog,
  },
  computed: {
    ...mapGetters('brandComponentProviderComponent', ['getProviderComponentList', 'getLoading']),
    ...mapFields('brandComponentProviderComponent', ['options', 'loading', 'totalRecords', 'selectedItemList',
      'searchTerm', 'availableInStock']),
  },
  methods: {
    ...mapActions('brandComponentProviderComponent', ['fetchProviderComponent', 'fetchDeleteSelected',
      'fetchUpdateSelected', 'fetchAddItem', 'fetchEditItem']),
    ...mapMutations('brandComponentProviderComponent', ['updateProviderComponent']),
    updateOptions() {
      this.fetchProviderComponent(this.brandComponentId)
    },
    onChangeSearch() {
      this.fetchProviderComponent(this.brandComponentId)
    },
    onDeleteSelected() {
      this.fetchDeleteSelected()
    },
    onUpdateSelected() {
      this.fetchUpdateSelected()
    },
    onAddItem() {
      this.fetchAddItem(this.brandComponentId)
    },
    onEditItem(item) {
      this.fetchEditItem(item)
    },
  },
  async mounted() {
    console.log()
    await this.fetchProviderComponent(this.brandComponentId);
  },
  data() {
    return {
      dialog: false,
      newItem: {part_number: null, mpn: null},
      columns: [
        {text: '', value: 'actions', sortable: false, filterable: false, divider: false,},
        {text: 'P/N', value: 'part_number', sortable: true, filterable: true, divider: true,},
        {text: 'MPN', value: 'brand_component__mpn', sortable: true, divider: true},
        {text: 'Provider', value: 'provider__name', sortable: true, divider: true},
        {text: 'Stock', value: 'instock', sortable: true, divider: true},
        {text: 'MOQ', value: 'moq', sortable: true, divider: true, width: 100},
        {text: 'Multiple', value: 'multiple', sortable: true, divider: true, width: 100},
        {text: 'Lead', value: 'lead', sortable: true, divider: true, width: 100},
        {text: 'Reel', value: 'reel', sortable: true, divider: true, width: 100},
        {text: 'Prices', value: 'prices', sortable: false, divider: true, width: 100},
        {text: 'Stocks', value: 'stocks', sortable: false, divider: true, width: 150},
        // {text: 'Source', value: 'source', sortable: false, divider: true, width: 100},
        {text: 'Last checked', value: 'last_check', sortable: true, divider: true, width: 100},
      ],
    }
  },
};
</script>

<style scoped lang="scss">
</style>